// MODAL UNLINK EXTRA MODULES
const unlinkExModulesModal = document.querySelector(".container_unlink_extra_modules_modal");

// get content modal unlink extra modules
body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_unlink_ex_modules");
  if (btnEl) {
    const url = btnEl.getAttribute("data-url");
    const id = btnEl.getAttribute("data-id")
    getContentModalUnlinkEx(url, id);
  }
})

// get content for modal link extra modules
function getContentModalUnlinkEx(urlRequest, id) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "id=" + id + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        setContentModalUnlinkEx(request.responseText);

        // console.log("response", request.responseText);
        // let response = JSON.parse(request.responseText);
       
        // if (response.status === "error") {
        //   console.log("error", request.responseText);
        //   return false;
        // }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

// set content for modal unlink extra modules
function setContentModalUnlinkEx(content) {
  const contentModal = unlinkExModulesModal.querySelector(".unlink_extra_modules_modal_content");
  contentModal.innerHTML = content;
  lockScroll();
  unlinkExModulesModal.style.display = "block";
}

// checkbox listener
unlinkExModulesModal && unlinkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".form__checkbox");
  if (btnEl) {
    if (btnEl.classList.contains("active")) {
      btnEl.querySelector("input").checked = false;
    } else {
      btnEl.querySelector("input").checked = true;
    }
    btnEl.classList.toggle("active");
  }
})

// radiobtns listener
unlinkExModulesModal && unlinkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".container_ex_radiobtn");
  if (btnEl) {
    if (!btnEl.classList.contains("active")) {
      unselectActiveRadioBtnUnlinkEx();
      btnEl.classList.add("active");
    }
  }
})

function unselectActiveRadioBtnUnlinkEx() {
  const tmpActiveRadioBtn = unlinkExModulesModal.querySelectorAll(".container_ex_radiobtn.active");
  tmpActiveRadioBtn.forEach(element => {
    element.classList.remove("active");
  });
}

// btn add unlink extra modules listener
unlinkExModulesModal && unlinkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest("#btn_unlink_ex_modal");
  if (btnEl) {
    // for checkbox
    // checkUnLinkExModCheckboxs();

    // for radio btn
    checkUnLinkExModRadiobtns();
  }
})

// check checkboxes in unlink extra modules modal
function checkUnLinkExModCheckboxs() {
  // if(!unlinkExModulesModal.querySelector(".form__checkbox.active")) {
  //   linkExModulesModal.querySelector(".error_msg_modal").style.display = "block";
  // } else {
  //   unlinkExModulesModal.querySelector(".error_msg_modal").style.display = "none";
  //   getCheckedCheckboxUnLinkExModules();
  // }
  getCheckedCheckboxUnLinkExModules();
}

// check radiobtns in link extra modules modal
function checkUnLinkExModRadiobtns() {
  if(!unlinkExModulesModal.querySelector(".container_ex_radiobtn.active")) {
    unlinkExModulesModal.querySelector(".error_msg_modal").style.display = "block";
  } else {
    unlinkExModulesModal.querySelector(".error_msg_modal").style.display = "none";
    getCheckedRadioBtnUnLinkExModules();
  }
}

// get checked checkboxes input in table
function getCheckedCheckboxUnLinkExModules() {
  let arrKeys = [];
  let allCheckboxs = unlinkExModulesModal.querySelectorAll(".form__checkbox.active");
  for(let checkbox of allCheckboxs) {
    arrKeys.push(checkbox.getAttribute("data-key"));
  }
  // console.log("arrKeys", arrKeys)

  // let urlBasket = document.querySelector("#btn_buy_upgrade_rent_modal").getAttribute("data-url");
  // addCardUpgrateRentProducts(urlBasket, arrKeys)
}

// get checked radiobtn input in table
function getCheckedRadioBtnUnLinkExModules() {
  let arrKeys = [];
  let allCheckboxs = unlinkExModulesModal.querySelectorAll(".container_ex_radiobtn.active input");
  for(let checkbox of allCheckboxs) {
    arrKeys.push(checkbox.getAttribute("value"));
  }

  const urlAttach = unlinkExModulesModal.querySelector("#btn_unlink_ex_modal").getAttribute("data-url");
  const addonId = unlinkExModulesModal.querySelector("#addon_id").getAttribute("value");

  deattachLinkExModules(urlAttach, addonId, arrKeys);
}

function deattachLinkExModules(urlAttach, addonId, arrKeys) {
  const request = new XMLHttpRequest();
  const url = urlAttach;
  const addonIds = [addonId];
  const params = "addon_ids=" + addonIds + "&serial_id=" + arrKeys + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      
      let response = JSON.parse(request.responseText);
      if (response.status === "ok") {

        response.cards.forEach(card => {
          setDataCardsFromResponse(card);
        });
      }
      // if (response.status === "error") {
      //   showAlert(response.message, true);
      // }
      if (response.status === "error404") {
        window.location.href = response.url;
      }

      unlockScroll();
      unlinkExModulesModal.style.display = "none";
    }
  });
  request.send(params);
}

// close modal unlink extra modules
unlinkExModulesModal && unlinkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".close_unlink_extra_modules");
  if (btnEl) {
    unlinkExModulesModal.style.display = "none";
    unlockScroll();
  }
})

unlinkExModulesModal && unlinkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_cancel_unlink_ex_modal");
  if (btnEl) {
    unlinkExModulesModal.style.display = "none";
    unlockScroll();
  }
})

window.addEventListener("click", function (event) {
  if (event.target == unlinkExModulesModal) {
    unlinkExModulesModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(unlinkExModulesModal);
// END MODAL UNLINK EXTRA MODULES

// MODAL LINK EXTRA MODULES
const linkExModulesModal = document.querySelector(".container_link_extra_modules_modal");

// get content modal link extra modules
body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_link_ex_modules");
  if (btnEl) {
    const url = btnEl.getAttribute("data-url");
    const id = btnEl.getAttribute("data-id")
    getContentModalLinkEx(url, id);
  }
})


// get content for modal link extra modules
function getContentModalLinkEx(urlRequest, id) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  const params = "id=" + id + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        setContentModalLinkEx(request.responseText);
        // console.log("response", request.responseText);
        // let response = JSON.parse(request.responseText);
       
        // if (response.status === "error") {
        //   console.log("error", request.responseText);
        //   return false;
        // }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

// set content for modal link extra modules
function setContentModalLinkEx(content) {
  const contentModal = linkExModulesModal.querySelector(".link_extra_modules_modal_content");
  contentModal.innerHTML = content;
  lockScroll();
  linkExModulesModal.style.display = "block";
}

// checkbox listener
linkExModulesModal && linkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".form__checkbox");
  if (btnEl) {
    if (btnEl.classList.contains("active")) {
      btnEl.querySelector("input").checked = false;
    } else {
      btnEl.querySelector("input").checked = true;
    }
    btnEl.classList.toggle("active");
  }
})

// radiobtns listener
linkExModulesModal && linkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".container_ex_radiobtn");
  if (btnEl) {
    if (!btnEl.classList.contains("active")) {
      unselectActiveRadioBtnLinkEx();
      btnEl.classList.add("active");
    }
  }
})

function unselectActiveRadioBtnLinkEx() {
  const tmpActiveRadioBtn = linkExModulesModal.querySelectorAll(".container_ex_radiobtn.active");
  tmpActiveRadioBtn.forEach(element => {
    element.classList.remove("active");
  });
}

// btn add link extra modules listener
linkExModulesModal && linkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest("#btn_link_ex_modal");
  if (btnEl) {
    if(linkExModulesModal.querySelector("#serial_id") !== null) {
      // for checkbox
      checkLinkExModCheckboxs();
    } else {
      // for radio btn
      checkLinkExModRadiobtns();
    }
  }
})

// check checkboxes in link extra modules modal
function checkLinkExModCheckboxs() {
  if(!linkExModulesModal.querySelector(".form__checkbox.active")) {
    linkExModulesModal.querySelector(".error_msg_modal").style.display = "block";
  } else {
    linkExModulesModal.querySelector(".error_msg_modal").style.display = "none";
    getCheckedCheckboxLinkExModules();
  }
}

// check radiobtns in link extra modules modal
function checkLinkExModRadiobtns() {
  if(!linkExModulesModal.querySelector(".container_ex_radiobtn.active")) {
    linkExModulesModal.querySelector(".error_msg_modal").style.display = "block";
  } else {
    linkExModulesModal.querySelector(".error_msg_modal").style.display = "none";
    getCheckedRadioBtnLinkExModules();
  }
}

// get checked checkboxes input in table
function getCheckedCheckboxLinkExModules() {
  let arrKeys = [];
  let allCheckboxs = linkExModulesModal.querySelectorAll(".form__checkbox.active");
  for(let checkbox of allCheckboxs) {
    arrKeys.push(checkbox.getAttribute("data-key"));
  }
  const urlAttach = document.querySelector("#btn_link_ex_modal").getAttribute("data-url");
  const serialId = linkExModulesModal.querySelector("#serial_id").getAttribute("value");
  // console.log(urlAttach, serialId, arrKeys)
  attachSerialLinkExModules(urlAttach, serialId, arrKeys);
}

// get checked radiobtn input in table
function getCheckedRadioBtnLinkExModules() {
  let arrKeys = [];
  let allCheckboxs = linkExModulesModal.querySelectorAll(".container_ex_radiobtn.active input");
  for(let checkbox of allCheckboxs) {
    arrKeys.push(checkbox.getAttribute("value"));
  }

  const urlAttach = document.querySelector("#btn_link_ex_modal").getAttribute("data-url");
  const addonId = linkExModulesModal.querySelector("#addon_id").getAttribute("value");
  // console.log(urlAttach, addonId, arrKeys)

  attachLinkExModules(urlAttach, addonId, arrKeys);
}

// attach addons
function attachLinkExModules(urlAttach, addonId, arrKeys) {
  const request = new XMLHttpRequest();
  const url = urlAttach;
  const addonIds = [addonId];
  const params = "addon_ids=" + addonIds + "&serial_id=" + arrKeys + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      console.log("attach", request.responseText)
      let response = JSON.parse(request.responseText);
      if (response.status === "ok") {

        response.cards.forEach(card => {
          setDataCardsFromResponse(card);
        });
      }
      // if (response.status === "error") {
      //   showAlert(response.message, true);
      // }
      if (response.status === "error404") {
        window.location.href = response.url;
      }

      unlockScroll();
      linkExModulesModal.style.display = "none";
      
    }
  });
  request.send(params);
}

// attach serials
function attachSerialLinkExModules(urlAttach, serialId, arrKeys) {
  const request = new XMLHttpRequest();
  const url = urlAttach;
  const addonIds = [serialId];
  const params = "addon_ids=" + arrKeys + "&serial_id=" + addonIds + "&_csrf=" + jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4 && request.status === 200) {
      // console.log("attach", request.responseText)
      let response = JSON.parse(request.responseText);
      if (response.status === "ok") {

        response.cards.forEach(card => {
          setDataCardsFromResponse(card);
        });
      }
      // if (response.status === "error") {
      //   showAlert(response.message, true);
      // }
      if (response.status === "error404") {
        window.location.href = response.url;
      }

      unlockScroll();
      linkExModulesModal.style.display = "none";
      
    }
  });
  request.send(params);
}

// close modal link extra modules
linkExModulesModal && linkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".close_link_extra_modules");
  if (btnEl) {
    linkExModulesModal.style.display = "none";
    unlockScroll();
  }
})

linkExModulesModal && linkExModulesModal.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_cancel_link_ex_modal");
  if (btnEl) {
    linkExModulesModal.style.display = "none";
    unlockScroll();
  }
})
window.addEventListener("click", function (event) {
  if (event.target == linkExModulesModal) {
    linkExModulesModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(linkExModulesModal);
// END MODAL LINK EXTRA MODULES

// MODAL LINK EXTRA MODULES NO LICENSE
const linkExModulesNoLicenseModal = document.querySelector(".container_modal_ex_module_no_license");
const closeLinkExModulesNoLicenseModal = document.querySelector(".close_modal_ex_module_no_license");
const cancelLinkExModulesNoLicenseBtn = document.querySelector(".modal_ex_module_no_license_btn_cancel");

// open modal link extra modules with no license
body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_link_ex_modules_no_license");
  if (btnEl) {
    lockScroll();
    linkExModulesNoLicenseModal.style.display = "block";
  }
})
// close modal link extra modules with no license
cancelLinkExModulesNoLicenseBtn &&
cancelLinkExModulesNoLicenseBtn.addEventListener("click", function () {
  linkExModulesNoLicenseModal.style.display = "none";
  unlockScroll();
});
closeLinkExModulesNoLicenseModal &&
closeLinkExModulesNoLicenseModal.addEventListener("click", function () {
  linkExModulesNoLicenseModal.style.display = "none";
  unlockScroll();
});
window.addEventListener("click", function (event) {
  if (event.target == linkExModulesNoLicenseModal) {
    linkExModulesNoLicenseModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(linkExModulesNoLicenseModal);

// END MODAL LINK EXTRA MODULES NO LICENSE

// MODAL LINK EXTRA MODULES FLOATING
const exModulesFloatingModal = document.querySelector(".container_modal_ex_module_floating");
const closeExModulesFloatingModal = document.querySelector(".close_modal_ex_module_floating");
const cancelExModulesFloatingBtn = document.querySelector(".modal_ex_module_floating_btn_cancel");

// open modal extra modules floating
body && body.addEventListener("click", (event) => {
  let elEvent = event.target;
  let btnEl = elEvent.closest(".btn_ex_modules_floating");
  if (btnEl) {
    lockScroll();
    exModulesFloatingModal.style.display = "block";
  }
})
// close modal extra modules floating
cancelExModulesFloatingBtn &&
cancelExModulesFloatingBtn.addEventListener("click", function () {
  exModulesFloatingModal.style.display = "none";
  unlockScroll();
});
closeExModulesFloatingModal &&
closeExModulesFloatingModal.addEventListener("click", function () {
  exModulesFloatingModal.style.display = "none";
  unlockScroll();
});
window.addEventListener("click", function (event) {
  if (event.target == exModulesFloatingModal) {
    exModulesFloatingModal.style.display = "none";
    unlockScroll();
  }
});
closeModalESC(exModulesFloatingModal);

// END MODAL LINK EXTRA MODULES FLOATING